module.exports = __webpack_public_path__ + "static/media/antirotate3icon.fc6f0c4b.svg";